import Axios from "axios";

const { REACT_APP_ENV } = process.env;
var URL = "https://apigatewaydev.greensense.ca";
var MICROSERVICE_URL = "https://microservicedev.greensense.ca"

if (REACT_APP_ENV === "production") {
    URL = "https://apigateway.greensense.ca";
    MICROSERVICE_URL = "https://microservice.greensense.ca"
}

Axios.defaults.timeout = 10 * 60 * 1000
Axios.defaults.withCredentials = true

const apiInstance = Axios.create();


const API = {
    logIn: function (source, username, password) {
        return apiInstance.post(
            `${URL}/auth`,
            {username: username, password: password},
            { withCredentials: true, cancelToken: source.token }
        );
    },
    logOut: function () {
        return apiInstance.get(
            `${URL}/endauth`,
            { withCredentials: true }
        );
    },
    recoverGet: function (source, username) {
        return apiInstance.get(
            `${URL}/auth/forgot-password?username=${username}`,
            { withCredentials: true, cancelToken: source.token }
        );
    },
    recoverPut: function (source, payload) {
        return apiInstance.put(
            `${URL}/auth/forgot-password`,
            payload,
            { withCredentials: true, cancelToken: source.token }
        );
    },
    changePassword: function (source, payload) {
        return apiInstance.post(
            `${URL}/auth/change`,
            payload,
            { withCredentials: true, cancelToken: source.token }
        );
    },
    getHistorical: function (source, start, end, channel_id) {
        return apiInstance.get(
            `${MICROSERVICE_URL}/historical?start=${start}&end=${end}&channel_id=${channel_id}`,
            { withCredentials: true, cancelToken: source.token, responseType: 'blob' }
        );
    },
    getCatConsumption: function (source, start, end, building) {
        return apiInstance.get(
            `${MICROSERVICE_URL}/categories?start=${start}&end=${end}&building=${building}`,
            { withCredentials: true, cancelToken: source.token }
        );
    },
    getCatConsumptionD: function (source, start, end, building, type) {
        return apiInstance.get(
            `${MICROSERVICE_URL}/categories/digital?start=${start}&end=${end}&building=${building}&type=${type}`,
            { withCredentials: true, cancelToken: source.token }
        );
    },
    getTemperature: function (source, building_id, frequency, start, end, unit) {
        return apiInstance.get(
            `${URL}/forecast/weather?building_id=${building_id}&time_step=${frequency}&start_date=${start}&end_date=${end}&units=${unit}`,
            { withCredentials: true, cancelToken: source.token }
        );
    },
    getSolar2: function (building, date, interval) {
        return apiInstance.get(
            `${URL}/forecast/solar2?building_id=${building}&date=${date}&interval=${interval}`,
            { withCredentials: true }
        );
    },
    getHierarchyConsumption: function (source, today, hour, building) {
        return apiInstance.get(
            `${MICROSERVICE_URL}/hierarchy_consumption?today=${today}&hour=${hour}&building=${building}`,
            { withCredentials: true, cancelToken: source.token }
        );
    },
    getHierarchyConsumptionD: function (source, building, today, hour, type) {
        return apiInstance.get(
            `${MICROSERVICE_URL}/digital/hierarchy_consumption?today=${today}&hour=${hour}&building=${building}&type=${type}`,
            { withCredentials: true, cancelToken: source.token }
        );
    },
    getPeakBatch: function (source, building, timestamp, unit = 'kva') {
        return apiInstance.get(
            `${MICROSERVICE_URL}/batchpeaks?building=${building}&timestamp=${timestamp}&unit=${unit}`,
            { withCredentials: true, cancelToken: source.token }
        );
    },
    getPeakBatchMonthly: function (source, building, timestamp, unit = 'kva') {
        return apiInstance.get(
            `${MICROSERVICE_URL}/batchpeaksmonthly?building=${building}&timestamp=${timestamp}&unit=${unit}`,
            { withCredentials: true, cancelToken: source.token }
        );
    },
    getKwhBatch: function (source, building, start, end) {
        return apiInstance.get(
            `${MICROSERVICE_URL}/batchconsumption?building=${building}&start=${start}&end=${end}`,
            { withCredentials: true, cancelToken: source.token }
        );
    },
    getBreakerBatch: function (source, building, start, end) {
        return apiInstance.get(
            `${MICROSERVICE_URL}/batchbreaker?building=${building}&start=${start}&end=${end}`,
            { withCredentials: true, cancelToken: source.token }
        );
    },
    getRuntimeBatch: function (source, building, start, end) {
        return apiInstance.get(
            `${MICROSERVICE_URL}/batchruntime?building=${building}&start=${start}&end=${end}`,
            { withCredentials: true, cancelToken: source.token }
        );
    },
    getCircuitRuntime: function (source, start, end, channel_id) {
        return apiInstance.get(
            `${MICROSERVICE_URL}/runtime?start=${start}&end=${end}&channel_id=${channel_id}`,
            { withCredentials: true, cancelToken: source.token }
        );
    },
    getElectricity: function (source, start, end, channel_id, detail, unit) {
        return apiInstance.get(
            `${MICROSERVICE_URL}/electrical?start=${start}&end=${end}&channel_id=${channel_id}&detail=${detail}&unit=${unit}`,
            { withCredentials: true, cancelToken: source.token }
        );
    },
    getSum: function (source, start, end, channel_id, unit) {
        return apiInstance.get(
            `${MICROSERVICE_URL}/e_sum?start=${start}&end=${end}&channel_id=${channel_id}&&unit=${unit}`,
            { withCredentials: true, cancelToken: source.token }
        );
    },
    getHarmonics: function (source, start, end, channel_id, detail, unit) {
        return apiInstance.get(
            `${MICROSERVICE_URL}/harmonics?start=${start}&end=${end}&channel_id=${channel_id}&detail=${detail}&unit=${unit}`,
            { withCredentials: true, cancelToken: source.token }
        );
    },
    getDigital: function (source, start, end, channel_id, detail, type) {
        return apiInstance.get(
            `${MICROSERVICE_URL}/digital?start=${start}&end=${end}&channel_id=${channel_id}&detail=${detail}&type=${type}`,
            { withCredentials: true, cancelToken: source.token }
        );
    },
    getCurrentReading: function (source, channel_id) {
        return apiInstance.get(
            `${MICROSERVICE_URL}/current?channel_id=${channel_id}`,
            { withCredentials: true, cancelToken: source.token }
        );
    },
    getCurrentReadingD: function (source, channel_id) {
        return apiInstance.get(
            `${MICROSERVICE_URL}/digital/current?channel_id=${channel_id}`,
            { withCredentials: true, cancelToken: source.token }
        );
    },
    getModelsE: function (source) {
        return apiInstance.get(
            `${URL}/cost/electricity/models`,
            { withCredentials: true, cancelToken: source.token }
        );
    },
    getModelsW: function (source) {
        return apiInstance.get(
            `${URL}/cost/water/models`,
            { withCredentials: true, cancelToken: source.token }
        );
    },
    getModelsG: function (source) {
        return apiInstance.get(
            `${URL}/cost/gas/models`,
            { withCredentials: true, cancelToken: source.token }
        );
    },
    getModelsCo: function (source) {
        return apiInstance.get(
            `${URL}/cost/co/models`,
            { withCredentials: true, cancelToken: source.token }
        );
    },
    getModelE: function (source, model) {
        return apiInstance.get(
            `${URL}/cost/electricity/model/${model}`,
            { withCredentials: true, cancelToken: source.token }
        );
    },
    getModelW: function (source, model) {
        return apiInstance.get(
            `${URL}/cost/water/model/${model}`,
            { withCredentials: true, cancelToken: source.token }
        );
    },
    getModelG: function (source, model) {
        return apiInstance.get(
            `${URL}/cost/gas/model/${model}`,
            { withCredentials: true, cancelToken: source.token }
        );
    },
    getModelCo: function (source, model) {
        return apiInstance.get(
            `${URL}/cost/co/model/${model}`,
            { withCredentials: true, cancelToken: source.token }
        );
    },
    postModelE: function (source, payload) {
        return apiInstance.post(
            `${URL}/cost/electricity/model`,
            payload,
            { withCredentials: true, cancelToken: source.token }
        );
    },
    postModelW: function (source, payload) {
        return apiInstance.post(
            `${URL}/cost/water/model`,
            payload,
            { withCredentials: true, cancelToken: source.token }
        );
    },
    postModelG: function (source, payload) {
        return apiInstance.post(
            `${URL}/cost/gas/model`,
            payload,
            { withCredentials: true, cancelToken: source.token }
        );
    },
    postModelCo: function (source, payload) {
        return apiInstance.post(
            `${URL}/cost/co/model`,
            payload,
            { withCredentials: true, cancelToken: source.token }
        );
    },
    putModelE: function (source, id, payload) {
        return apiInstance.put(
            `${URL}/cost/electricity/model?id=${id}`,
            payload,
            { withCredentials: true, cancelToken: source.token }
        );
    },
    putModelW: function (source, id, payload) {
        return apiInstance.put(
            `${URL}/cost/water/model?id=${id}`,
            payload,
            { withCredentials: true, cancelToken: source.token }
        );
    },
    putModelG: function (source, id, payload) {
        return apiInstance.put(
            `${URL}/cost/gas/model?id=${id}`,
            payload,
            { withCredentials: true, cancelToken: source.token }
        );
    },
    putModelCo: function (source, id, payload) {
        return apiInstance.put(
            `${URL}/cost/co/model?id=${id}`,
            payload,
            { withCredentials: true, cancelToken: source.token }
        );
    },
    postValueE: function (source, payload) {
        return apiInstance.post(
            `${URL}/cost/electricity/values`,
            payload,
            { withCredentials: true, cancelToken: source.token }
        );
    },
    postValueW: function (source, payload) {
        return apiInstance.post(
            `${URL}/cost/water/values`,
            payload,
            { withCredentials: true, cancelToken: source.token }
        );
    },
    postValueG: function (source, payload) {
        return apiInstance.post(
            `${URL}/cost/gas/values`,
            payload,
            { withCredentials: true, cancelToken: source.token }
        );
    },
    postValueCo: function (source, payload) {
        return apiInstance.post(
            `${URL}/cost/co/values`,
            payload,
            { withCredentials: true, cancelToken: source.token }
        );
    },
    putValueE: function (source, id, payload) {
        return apiInstance.put(
            `${URL}/cost/electricity/values?id=${id}`,
            payload,
            { withCredentials: true, cancelToken: source.token }
        );
    },
    putValueW: function (source, id, payload) {
        return apiInstance.put(
            `${URL}/cost/water/values?id=${id}`,
            payload,
            { withCredentials: true, cancelToken: source.token }
        );
    },
    putValueG: function (source, id, payload) {
        return apiInstance.put(
            `${URL}/cost/gas/values?id=${id}`,
            payload,
            { withCredentials: true, cancelToken: source.token }
        );
    },
    putValueCo: function (source, id, payload) {
        return apiInstance.put(
            `${URL}/cost/co/values?id=${id}`,
            payload,
            { withCredentials: true, cancelToken: source.token }
        );
    },
    getPriceE: function (source, start, end, channel_id, kwh = false) {
        return apiInstance.get(
            `${MICROSERVICE_URL}/cost/electrical?start=${start}&end=${end}&channel_id=${channel_id}${kwh ? "&kwh=true" : ""}`,
            { withCredentials: true, cancelToken: source.token }
        );
    },
    getPriceW: function (source, start, end, channel_id) {
        return apiInstance.get(
            `${MICROSERVICE_URL}/cost/water?start=${start}&end=${end}&channel_id=${channel_id}`,
            { withCredentials: true, cancelToken: source.token }
        );
    },
    getPriceG: function (source, start, end, channel_id) {
        return apiInstance.get(
            `${MICROSERVICE_URL}/cost/gas?start=${start}&end=${end}&channel_id=${channel_id}`,
            { withCredentials: true, cancelToken: source.token }
        );
    },
    getPriceCoElectric: function (source, start, end, channel_id, detail) {
        return apiInstance.get(
            `${MICROSERVICE_URL}/cost/co/electric?start=${start}&end=${end}&channel_id=${channel_id}&detail=${detail}`,
            { withCredentials: true, cancelToken: source.token }
        );
    },
    getPriceCoGas: function (source, start, end, channel_id, detail) {
        return apiInstance.get(
            `${MICROSERVICE_URL}/cost/co/gas?start=${start}&end=${end}&channel_id=${channel_id}&detail=${detail}`,
            { withCredentials: true, cancelToken: source.token }
        );
    },
    getEuiTypes: function (source) {
        return apiInstance.get(
            `${URL}/eui/types`,
            { withCredentials: true, cancelToken: source.token }
        );
    },
    getUtilityAccounts: function (source, buildingId) {
        return apiInstance.get(
            `${URL}/utilitybill/accounts/${buildingId}`,
            { withCredentials: true, cancelToken: source.token }
        );
    },
    getUtilityAccountsByProprety: function (source, propertyId) {
        return apiInstance.get(
            `${URL}/utilitybill/accounts/property/${propertyId}`,
            { withCredentials: true, cancelToken: source.token }
        );
    },
    getUtilityBills: function (source, buildingId) {
        return apiInstance.get(
            `${URL}/utilitybill/building/${buildingId}`,
            { withCredentials: true, cancelToken: source.token }
        );
    },
    getBillLink: function (source, bill_id) {
        return apiInstance.get(
            `${URL}/utilitybill/bill/link?id=${bill_id}`,
            { withCredentials: true, cancelToken: source.token }
        );
    },
    getBuildingUtilityBills: function (source, buildingId, start, end) {
        return apiInstance.get(
            `${URL}/utilitybill/bills?building=${buildingId}&start=${start}&end=${end}`,
            { withCredentials: true, cancelToken: source.token }
        )
    },
    postUtilityAccount: function (source, payload) {
        return apiInstance.post(
            `${URL}/utilitybill/account`,
            payload,
            { withCredentials: true, cancelToken: source.token }
        );
    },
    putUtilityAccount: function (source, payload, accountId) {
        return apiInstance.put(
            `${URL}/utilitybill/account/${accountId}`,
            payload,
            { withCredentials: true, cancelToken: source.token }
        );
    },
    postUtilityBills: function (source, payload) {
        return apiInstance.post(
            `${URL}/utilitybill/bill`,
            payload,
            { withCredentials: true, cancelToken: source.token }
        );
    },
    putUtilityBill: function (payload, billId) {
        return apiInstance.put(
            `${URL}/utilitybill/bill/${billId}`,
            payload,
            { withCredentials: true }
        );
    },
    processPdf: function (source, payload) {
        return apiInstance.post(
            `${URL}/utilitybill/pdf`,
            payload,
            { withCredentials: true, cancelToken: source.token }
        );
    },
    processPages: function (source, payload) {
        return apiInstance.post(
            `${URL}/utilitybill/pages`,
            payload,
            { withCredentials: true, cancelToken: source.token }
        );
    },
    getProcessedPdf: function (source, jobId, fileKey) {
        return apiInstance.patch(
            `${URL}/utilitybill/pdf?id=${jobId}&file=${fileKey}`,
            {},
            { withCredentials: true, cancelToken: source.token }
        );
    },
    processImage: function (source, payload) {
        return apiInstance.post(
            `${URL}/utilitybill/process`,
            payload,
            { withCredentials: true, cancelToken: source.token }
        );
    },
    getEuiType: function (source, typeId) {
        return apiInstance.get(
            `${URL}/eui/type/${typeId}`,
            { withCredentials: true, cancelToken: source.token }
        );
    },
    postEuiType: function (source, payload) {
        return apiInstance.post(
            `${URL}/eui/type`,
            payload,
            { withCredentials: true, cancelToken: source.token }
        );
    },
    putEuiType: function (source, typeId, payload) {
        return apiInstance.put(
            `${URL}/eui/type/${typeId}`,
            payload,
            { withCredentials: true, cancelToken: source.token }
        );
    },
    postEuiFactor: function (source, payload) {
        return apiInstance.post(
            `${URL}/eui/factor`,
            payload,
            { withCredentials: true, cancelToken: source.token }
        );
    },
    putEuiFactor: function (source, factorId, payload) {
        return apiInstance.put(
            `${URL}/eui/factor/${factorId}`,
            payload,
            { withCredentials: true, cancelToken: source.token }
        );
    },
    getRoles: function (source) {
        return apiInstance.get(
            `${URL}/roles`,
            { withCredentials: true, cancelToken: source.token }
        );
    },
    getRole: function (source, role) {
        return apiInstance.get(
            `${URL}/role/${role}`,
            { withCredentials: true, cancelToken: source.token }
        );
    },
    postRole: function (source, payload) {
        return apiInstance.post(
            `${URL}/roles`,
            payload,
            { withCredentials: true, cancelToken: source.token }
        );
    },
    putRole: function (source, role, payload) {
        return apiInstance.put(
            `${URL}/roles/${role}`,
            payload,
            { withCredentials: true, cancelToken: source.token }
        );
    },
    updateCorrespondance: function (payload) {
        return apiInstance.put(
            `${URL}/user/correspondance`,
            payload,
            { withCredentials: true }
        );
    },
    getClients: function (source) {
        return apiInstance.get(
            `${URL}/clients`,
            { withCredentials: true, cancelToken: source.token }
        );
    },
    getClient: function (source, client) {
        return apiInstance.get(
            `${URL}/client/${client}`,
            { withCredentials: true, cancelToken: source.token }
        );
    },
    postClient: function (source, payload) {
        return apiInstance.post(
            `${URL}/clients`,
            payload,
            { withCredentials: true, cancelToken: source.token }
        );
    },
    putClient: function (source, client, payload) {
        return apiInstance.put(
            `${URL}/clients/${client}`,
            payload,
            { withCredentials: true, cancelToken: source.token }
        );
    },
    getBuildings: function (source) {
        return apiInstance.get(
            `${URL}/buildings`,
            { withCredentials: true, cancelToken: source.token }
        );
    },
    getBuildingBasic: function (source, building) {
        return apiInstance.get(
            `${URL}/building/${building}`,
            { withCredentials: true, cancelToken: source.token }
        );
    },
    getBuilding: function (source, building) {
        return apiInstance.get(
            `${MICROSERVICE_URL}/building/${building}`,
            { withCredentials: true, cancelToken: source.token }
        );
    },
    postBuilding: function (source, payload) {
        return apiInstance.post(
            `${URL}/buildings`,
            payload,
            { withCredentials: true, cancelToken: source.token }
        );
    },
    putBuilding: function (source, building, payload) {
        return apiInstance.put(
            `${URL}/buildings/${building}`,
            payload,
            { withCredentials: true, cancelToken: source.token }
        );
    },
    getDevices: function (source) {
        return apiInstance.get(
            `${URL}/devices`,
            { withCredentials: true, cancelToken: source.token }
        );
    },
    getDigitalChannels: function (source) {
        return apiInstance.get(
            `${URL}/digital/channels`,
            { withCredentials: true, cancelToken: source.token }
        );
    },
    getActuatorStatus: function (source, id) {
        return apiInstance.get(
            `${MICROSERVICE_URL}/actuator?id=${id}`,
            { withCredentials: true, cancelToken: source.token }
        );
    },
    comandActuator: function (id, pos) {
        return apiInstance.post(
            `${MICROSERVICE_URL}/actuator?id=${id}&pos=${pos}`,
            {},
            { withCredentials: true }
        );
    },
    getActuators: function (source) {
        return apiInstance.get(
            `${URL}/actuators`,
            { withCredentials: true, cancelToken: source.token }
        );
    },
    getActuatorHours: function (source, actuator) {
        return apiInstance.get(
            `${URL}/actuator/hours/${actuator}`,
            { withCredentials: true, cancelToken: source.token }
        );
    },
    getActuator: function (source, actuator) {
        return apiInstance.get(
            `${URL}/actuator/${actuator}`,
            { withCredentials: true, cancelToken: source.token }
        );
    },
    createActuator: function (source, payload) {
        return apiInstance.post(
            `${URL}/actuator`,
            payload,
            { withCredentials: true, cancelToken: source.token }
        );
    },
    updateActuator: function (source, actuator_id, payload) {
        return apiInstance.put(
            `${URL}/actuator/${actuator_id}`,
            payload,
            { withCredentials: true, cancelToken: source.token }
        );
    },
    putActuatorHours: function (source, actuator_id, payload) {
        return apiInstance.put(
            `${URL}/actuator/hours/${actuator_id}`,
            payload,
            { withCredentials: true, cancelToken: source.token }
        );
    },
    getDevicePictures: function (source, channel_id) {
        return apiInstance.get(
            `${URL}/photos?channel_id=${channel_id}`,
            { withCredentials: true, cancelToken: source.token }
        );
    },
    getCircuit: function (source, channel_id) {
        return apiInstance.get(
            `${URL}/circuit?channel_id=${channel_id}`,
            { withCredentials: true, cancelToken: source.token }
        );
    },
    updateCircuit: function (source, channel_id, payload) {
        return apiInstance.put(
            `${URL}/circuit?channel_id=${channel_id}`,
            payload,
            { withCredentials: true, cancelToken: source.token }
        );
    },
    uploadImage: function (payload) {
        return apiInstance.post(
            `${URL}/image`,
            payload,
            { withCredentials: true }
        );
    },
    uploadFile: function (payload) {
        return apiInstance.post(
            `${URL}/file`,
            payload,
            { withCredentials: true }
        );
    },
    scanStatus: function (payload) {
        return apiInstance.put(
            `${URL}/scan`,
            payload,
            { withCredentials: true }
        );
    },
    getScannedCode: function (payload) {
        return apiInstance.post(
            `${URL}/scan`,
            payload,
            { withCredentials: true }
        )
    },
    getDevice: function (source, device) {
        return apiInstance.get(
            `${URL}/device/${device}`,
            { withCredentials: true, cancelToken: source.token }
        );
    },
    postDevice: function (source, payload) {
        return apiInstance.post(
            `${URL}/device`,
            payload,
            { withCredentials: true, cancelToken: source.token }
        );
    },
    putDevice: function (source, device, payload) {
        return apiInstance.put(
            `${URL}/device/${device}`,
            payload,
            { withCredentials: true, cancelToken: source.token }
        );
    },
    postChannel: function (source, payload) {
        return apiInstance.post(
            `${URL}/channel`,
            payload,
            { withCredentials: true, cancelToken: source.token }
        );
    },
    putChannel: function (source, channelId, payload) {
        return apiInstance.put(
            `${URL}/channel/${channelId}`,
            payload,
            { withCredentials: true, cancelToken: source.token }
        );
    },
    putAlert: function (source, alert, payload) {
        return apiInstance.put(
            `${URL}/readalert/${alert}`,
            payload,
            { withCredentials: true, cancelToken: source.token }
        );
    },
    getUsers: function (source) {
        return apiInstance.get(
            `${URL}/users`,
            { withCredentials: true, cancelToken: source.token }
        );
    },
    getUser: function (source) {
        return apiInstance.get(
            `${MICROSERVICE_URL}/user?limited=true`,
            { withCredentials: true, cancelToken: source.token }
        );
    },
    getUserInfo: function (source, user) {
        return apiInstance.get(
            `${URL}/userinfo/${user}`,
            { withCredentials: true, cancelToken: source.token }
        );
    },
    postUser: function (source, payload) {
        return apiInstance.post(
            `${URL}/users`,
            payload,
            { withCredentials: true, cancelToken: source.token }
        );
    },
    putUser: function (source, user, payload) {
        return apiInstance.put(
            `${URL}/users/${user}`,
            payload,
            { withCredentials: true, cancelToken: source.token }
        );
    },
    getBuildingsUsers: function (source) {
        return apiInstance.get(
            `${URL}/buildings/users`,
            { withCredentials: true, cancelToken: source.token }
        );
    },
    getBuildingUsers: function (source, building_id) {
        return apiInstance.get(
            `${URL}/building/users/${building_id}`,
            { withCredentials: true, cancelToken: source.token }
        );
    },
    getBuildingOperators: function (source) {
        return apiInstance.get(
            `${URL}/buildings/operators`,
            { withCredentials: true, cancelToken: source.token }
        );
    },
    getOperators: function (source) {
        return apiInstance.get(
            `${URL}/operators`,
            { withCredentials: true, cancelToken: source.token }
        );
    },
    getOperator: function (source, operator) {
        return apiInstance.get(
            `${URL}/operator/${operator}`,
            { withCredentials: true, cancelToken: source.token }
        );
    },
    postOperator: function (source, payload) {
        return apiInstance.post(
            `${URL}/operators`,
            payload,
            { withCredentials: true, cancelToken: source.token }
        );
    },
    putOperator: function (source, operator, payload) {
        return apiInstance.put(
            `${URL}/operators/${operator}`,
            payload,
            { withCredentials: true, cancelToken: source.token }
        );
    },
    getHours: function (source, building) {
        return apiInstance.get(
            `${URL}/ophours/${building}`,
            { withCredentials: true, cancelToken: source.token }
        );
    },
    getOpHoursRange: function (source, building, start, end) {
        return apiInstance.get(
            `${URL}/ophours/${building}?start=${start}&end=${end}`,
            { withCredentials: true, cancelToken: source.token }
        );
    },
    putHours: function (source, building, payload) {
        return apiInstance.put(
            `${URL}/ophours/${building}`,
            payload,
            { withCredentials: true, cancelToken: source.token }
        );
    },
    getVersion: function (source) {
        return apiInstance.get(
            `${URL}/version`,
            { withCredentials: true, cancelToken: source.token }
        );
    },
    getFaq: function (source) {
        return apiInstance.get(
            `${URL}/faq`,
            { withCredentials: true, cancelToken: source.token }
        );
    },
    getActivities: function (source, buildingId) {
        return apiInstance.get(
            `${URL}/activities/${buildingId}`,
            { withCredentials: true, cancelToken: source.token }
        );
    },
    createActivity: function (payload) {
        return apiInstance.post(
            `${URL}/activity`,
            payload,
            { withCredentials: true }
        );
    },
    updateActivity: function (payload, activity) {
        return apiInstance.put(
            `${URL}/activity/${activity}`,
            payload,
            { withCredentials: true }
        );
    },
    getLinks: function (source, buildingId) {
        return apiInstance.get(
            `${URL}/links/${buildingId}`,
            { withCredentials: true, cancelToken: source.token }
        );
    },
    createLink: function (payload) {
        return apiInstance.post(
            `${URL}/link`,
            payload,
            { withCredentials: true }
        );
    },
    updateLink: function (payload, link) {
        return apiInstance.put(
            `${URL}/link/${link}`,
            payload,
            { withCredentials: true }
        );
    },
    createImpact: function (payload) {
        return apiInstance.post(
            `${URL}/impact`,
            payload,
            { withCredentials: true }
        );
    },
    updateImpact: function (payload, id) {
        return apiInstance.put(
            `${URL}/impact/${id}`,
            payload,
            { withCredentials: true }
        );
    },
    getConservationFiles: function (source, id) {
        return apiInstance.get(
            `${URL}/impact/files/${id}`,
            { withCredentials: true, cancelToken: source.token }
        );
    },
    getPublicImpact: function (source, type, level, id) {
        return apiInstance.get(
            `${URL}/public/impact?type=${type}&level=${level}&id=${id}`,
            { withCredentials: true, cancelToken: source.token }
        );
    },
    getPublicBuilding: function (source, id) {
        return apiInstance.get(
            `${URL}/public/building/${id}`,
            { withCredentials: true, cancelToken: source.token }
        );
    },
    getPublicCatConsumption: function (source, start, end, building) {
        return apiInstance.get(
            `${MICROSERVICE_URL}/public/categories?start=${start}&end=${end}&building=${building}`,
            { withCredentials: true, cancelToken: source.token }
        );
    },
    getPublicClient: function (source, id) {
        return apiInstance.get(
            `${URL}/public/client/${id}`,
            { withCredentials: true, cancelToken: source.token }
        );
    },
    getPublicGenerationRecent: function (source, id) {
        return apiInstance.get(
            `${MICROSERVICE_URL}/public/generation/recent?building=${id}`,
            { withCredentials: true, cancelToken: source.token }
        );
    },
    getPublicGenerationTotal: function (source, id) {
        return apiInstance.get(
            `${MICROSERVICE_URL}/public/generation/total?building=${id}`,
            { withCredentials: true, cancelToken: source.token }
        );
    },
    getPublicImages: function (source) {
        return apiInstance.get(
            `${URL}/public/images`,
            { withCredentials: true, cancelToken: source.token }
        );
    },
    getPublicCurrentReading: function (source, building) {
        return apiInstance.get(
            `${MICROSERVICE_URL}/public/electric/current?building=${building}`,
            { withCredentials: true, cancelToken: source.token }
        );
    },
    getPublicCurrentReadingD: function (source, building, type) {
        return apiInstance.get(
            `${MICROSERVICE_URL}/public/digital/current?building=${building}&type=${type}`,
            { withCredentials: true, cancelToken: source.token }
        );
    },
    getMaintenanceGroups: function (source, buildingId) {
        return apiInstance.get(
            `${URL}/maintenance/groups/${buildingId}`,
            { withCredentials: true, cancelToken: source.token }
        );
    },
    getMaintenanceGroup: function (source, buildingId) {
        return apiInstance.get(
            `${URL}/maintenance/group/${buildingId}`,
            { withCredentials: true, cancelToken: source.token }
        );
    },
    getMaintenanceGroupByCircuit: function (source, channel_id) {
        return apiInstance.get(
            `${URL}/maintenance/circuit?channel_id=${channel_id}`,
            { withCredentials: true, cancelToken: source.token }
        );
    },
    createMaintenanceGroup: function (payload) {
        return apiInstance.post(
            `${URL}/maintenance/group`,
            payload,
            { withCredentials: true }
        );
    },
    updateMaintenanceGroup: function (payload, group) {
        return apiInstance.put(
            `${URL}/maintenance/group/${group}`,
            payload,
            { withCredentials: true }
        );
    },
    createMaintenanceActivity: function (payload) {
        return apiInstance.post(
            `${URL}/maintenance/activity`,
            payload,
            { withCredentials: true }
        );
    },
    getMaintenancePhotos: function (source, log_id) {
        return apiInstance.get(
            `${URL}/maintenance/photos?log_id=${log_id}`,
            { withCredentials: true, cancelToken: source.token }
        );
    },
    updateMaintenanceActivity: function (payload, activity) {
        return apiInstance.put(
            `${URL}/maintenance/activity/${activity}`,
            payload,
            { withCredentials: true }
        );
    },
    createMaintenanceLog: function (payload) {
        return apiInstance.post(
            `${URL}/maintenance/log`,
            payload,
            { withCredentials: true }
        );
    },
    updateMaintenanceLog: function (payload, log) {
        return apiInstance.put(
            `${URL}/maintenance/log/${log}`,
            payload,
            { withCredentials: true }
        );
    },
    createMaintenanceSubscriber: function (payload) {
        return apiInstance.post(
            `${URL}/maintenance/subscriber`,
            payload,
            { withCredentials: true }
        )
    },
    updateMaintenanceSubscriber: function (payload, id) {
        return apiInstance.put(
            `${URL}/maintenance/subscriber/${id}`,
            payload,
            { withCredentials: true }
        )
    },
    createSubscriber: function (payload) {
        return apiInstance.post(
            `${URL}/alert/subscriber`,
            payload,
            { withCredentials: true }
        )
    },
    updateSubscriber: function (payload, id) {
        return apiInstance.put(
            `${URL}/alert/subscriber/${id}`,
            payload,
            { withCredentials: true }
        )
    },
    getAlertSeries: function (source, start, end, channel_id, detail, type) {
        return apiInstance.get(
            `${MICROSERVICE_URL}/alert/series?start=${start}&end=${end}&channel_id=${channel_id}&detail=${detail}&type=${type}`,
            { withCredentials: true, cancelToken: source.token }
        );
    },
    getMaintenanceSeries: function (source, start, end, channel_id, detail) {
        return apiInstance.get(
            `${MICROSERVICE_URL}/maintenance/series?start=${start}&end=${end}&channel_id=${channel_id}&detail=${detail}`,
            { withCredentials: true, cancelToken: source.token }
        );
    },
    getActuatorSeries: function (source, start, end, actuator_id) {
        return apiInstance.get(
            `${MICROSERVICE_URL}/digital/status?start=${start}&end=${end}&actuator_id=${actuator_id}`,
            { withCredentials: true, cancelToken: source.token }
        );
    },
    getAlertsByCirctuit: function (source, building_id) {
        return apiInstance.get(
            `${URL}/alert/count?building_id=${building_id}`,
            { withCredentials: true, cancelToken: source.token }
        );
    },
    getAlertTypes: function (source) {
        return apiInstance.get(
            `${URL}/alert/types`,
            { withCredentials: true, cancelToken: source.token }
        );
    },
    getAlertGroups: function (source, buildingId) {
        return apiInstance.get(
            `${URL}/alert/groups/${buildingId}`,
            { withCredentials: true, cancelToken: source.token }
        );
    },
    getAlertGroup: function (groupId) {
        return apiInstance.get(
            `${URL}/alert/group/${groupId}`,
            { withCredentials: true }
        );
    },
    getSubLogs: function (log_id, page) {
        return apiInstance.get(
            `${URL}/alert/sublog?id=${log_id}&page=${page}`,
            { withCredentials: true }
        );
    },
    getAlertGroupByCircuit: function (source, channel_id) {
        return apiInstance.get(
            `${URL}/alert/circuit?channel_id=${channel_id}`,
            { withCredentials: true, cancelToken: source.token }
        );
    },
    getOpenSubLogCount(source, log_id) {
        return apiInstance.get(
            `${URL}/alert/sublog/count/${log_id}`,
            { withCredentials: true, cancelToken: source.token }
        );
    },
    createAlertGroup: function (payload) {
        return apiInstance.post(
            `${URL}/alert/group`,
            payload,
            { withCredentials: true }
        );
    },
    updateAlertGroup: function (payload, group) {
        return apiInstance.put(
            `${URL}/alert/group?id=${group}`,
            payload,
            { withCredentials: true }
        );
    },
    getAlertGroupTagTypes(source) {
        return apiInstance.get(
            `${URL}/alert/tag/types`,
            { withCredentials: true, cancelToken: source.token }
        );
    },
    createAlertActivity: function (payload) {
        return apiInstance.post(
            `${URL}/alert/activity`,
            payload,
            { withCredentials: true }
        );
    },
    updateAlertActivity: function (payload, activity) {
        return apiInstance.put(
            `${URL}/alert/activity/${activity}`,
            payload,
            { withCredentials: true }
        );
    },
    createWorkflow: function (payload) {
        return apiInstance.post(
            `${URL}/alert/workflow`,
            payload,
            { withCredentials: true }
        );
    },
    updateWorkflow: function (payload, id) {
        return apiInstance.put(
            `${URL}/alert/workflow/${id}`,
            payload,
            { withCredentials: true }
        );
    },
    updateLog: function (id, payload) {
        return apiInstance.put(
            `${URL}/alert/log/${id}`,
            payload,
            { withCredentials: true }
        );
    },
    closeAllSubLogs: function (id, payload) {
        return apiInstance.put(
            `${URL}/alert/sublog/by_log/${id}`,
            payload,
            { withCredentials: true }
        );
    },
    updateSubLog: function (payload, id) {
        return apiInstance.put(
            `${URL}/alert/sublog/${id}`,
            payload,
            { withCredentials: true }
        );
    },
    updateSubLogBulk: function (payload, id) {
        return apiInstance.put(
            `${URL}/alert/sublog/bulk`,
            payload,
            { withCredentials: true }
        );
    },
    cancelToken: function () {
        const cancelToken = Axios.CancelToken;
        return cancelToken.source();
    },
    cancel: function (token) {
        if (token) token.cancel('cancelling');
    }
};

export default API; 